import type { ProdutoDoRelatorio } from '../types';

/**
 * Fonte única das flags: aba, rota e gateway precisam concordar sobre demo × api. A leitura fica
 * literal (`process.env.NEXT_PUBLIC_…`) porque o Next só inlina no bundle o acesso escrito assim.
 */
const flagsDoProduto = (produto: ProdutoDoRelatorio) =>
  ({
    negociacao: {
      modo: process.env.NEXT_PUBLIC_NEGOTIATION_REPORTS_MODE,
      previa: process.env.NEXT_PUBLIC_NEGOTIATION_REPORTS_PREVIEW,
    },
    notificacao: {
      modo: process.env.NEXT_PUBLIC_NOTIFICATION_REPORTS_MODE,
      previa: process.env.NEXT_PUBLIC_NOTIFICATION_REPORTS_PREVIEW,
    },
  })[produto];

export const relatoriosEmModoApi = (produto: ProdutoDoRelatorio): boolean =>
  flagsDoProduto(produto).modo === 'api';

/** Esconde a integração inacabada a menos que o modo api ou a prévia estejam ligados. */
export const relatoriosHabilitados = (produto: ProdutoDoRelatorio): boolean =>
  relatoriosEmModoApi(produto) || flagsDoProduto(produto).previa === 'true';
